<template>
    <div class="DeviceStatus" >
        <Title firstName="设备状态" lastName="EQUIPMENT STATUS"/>
        <div class="echarts">
            <div class="state">
                <div class="item">
                    <div class="imgshow"><span>门禁</span></div>
                    <div class="title">运行/故障</div>
                    <div class="num">{{total}}<span>/--</span></div>
                </div>
                <div class="item">
                    <div class="imgshow"><span>监控</span></div>
                    <div class="title">运行/故障</div>
                    <div class="num">--<span>/--</span></div>
                </div>
                <div class="item">
                    <div class="imgshow"><span style="font-size:14rem">电子<br>围栏</span></div>
                    <div class="title">入侵检测</div>
                    <div class="num">--</div>
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
export default {
    data(){
        return {
            total:'--',
        }
    },
    components:{
        Title,Graph,charts
    },
    mounted(){
        this.getDoorsList()
    },
    methods:{
        // 获取门禁列表和状态 
        async getDoorsList(){
            let data = {
                pageNo:1,
                pageSize:100
            }
            let res = await this.$http.getDoorsList(data)
            let res1 = await this.$http.getDoorsStatus({doorIndexCode:res.data.data.list[0].indexCode})
            let sum = 0
            if(res1){
                res1.data.data.authDoorList.forEach(item =>{
                    if(item.doorState== 1 || item.doorState== 2){
                        sum ++
                    }
                })
                this.total = sum
            }

        }
    },
}
</script>

<style lang="less" scoped>
    .DeviceStatus{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 7.4vh;
        left: 2vw;
        z-index: 1;
        
        .echarts{
            position: relative;
            height: 18.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
           .state{
                padding: 1.2vh 1.5vw;
                display: flex;
                justify-content: space-between;
                font-size: 14rem;
                margin-top: 25rem;
                text-align: center;
                color:#fff;
                .item{
                    background: url("../../../../assets/img/bg2.png") no-repeat top center;
                }
                .imgshow{
                    width: 83rem;
                    height: 61rem;
                    background-size: 100% 100%;
                    text-align: center;
                    padding: 0 20rem;
                    font-size: 16rem;
                    display:table-cell;
                    vertical-align:middle;
                    span{
                        display: inline-block;
                        display: contents;
                    }
                }
                .title{
                    margin-top: 25rem;
                    color: #E6F3FD;
                }
                .num{
                    padding-top: 3rem;
                    font-size: 20rem;
                    color: #00DEFF;
                    font-family: zcoolqingkehuangyouti;
                    font-weight: 400;
                    span{
                        font-size: 14rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
    .power1{
        top: 30.3vh;
    }

</style>